module.exports = __webpack_public_path__ + "static/media/article1_slide2_main.086fc4d2.jpg";